<div>
    <div style="margin-left: 80%;  margin-bottom: 2%">
        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" (click)="printSelectedSections()"  ngxPrint>
            print
        </button>
        <button mat-dialog-close class="btn noPrint">
            Close
        </button>
    </div>
    <ng-container *ngFor="let item of subData">
    <div class="container" [id]="item.id" style="line-height: 1.6rem; width: 80%;">
        <div class="pawati mb-4" >
            <label style="margin-left: 10px;" class="noPrint">
                <input type="checkbox" [(ngModel)]="item.printEnabled" > Print Section
            </label>
            <div class="row" style="margin-left: 5%;border-width: 0 0 1px 0;border-style: solid; border-color: black;">
                <div class="col-2">
                    <img src="../../../assets/img/brand/blue.png" alt="" loading="lazy" width="100" height="100">
                </div>
                <div class="col-10" style="
                font-size: small;
            ">
                    <span>हिंदुस्थान प्रकाशन संस्था</span><br />
                    <span>मुख्य कार्यालय: १२, कामत औद्योगिक वसाहत, ३९६, वीर सावरकर मार्ग, प्रभादेवी, मुंबई - ४००
                        ०२५. दूरध्वनी: २४२२१४४०.</span><br />
                    <!-- <span>दूरध्वनी: २४२२१४४०</span><br /> -->
                    <span>प्रशासकीय कार्यालय : हिंदुस्थान प्रकाशन संस्था 116-119, शिल्पीन सेंटर, पहिला मजला,</span><br />
                    <span>गं. द. आंबेकर मार्ग वडाळा, मुंबई - 400 031. मो.:9967570531 ,ई-पत्र: vivekwklvargani&#64;gmail.com</span><br />
                    <!-- <span>मो.:9967570531</span><br />
                    <span>ई-पत्र: vivekwklvargani&#64;gmail.com</span> -->
                </div>
            </div>
            <div class="row" style="margin-left: 5%;font-size: small;">
                <div class="col-4" style="margin-top: 1%;">पावती क्र : {{ item['rcpt_no'] }}</div>
                <div class="col-3" style="border: 1px solid black;padding: 5px; border-radius: 5px; margin-top: 4px;">वर्गणीदार नोंदणी
                    पावती
                </div>
                <!-- <div class="col-1"></div> -->
                <div class="col-3" style="margin-top: 1%;">पावती दि : {{ item['crdt_voucher_date'] | date:'dd/MM/yyyy' }}</div>
            </div>
            <div class="row" style="margin-left: 10%;margin-top: 1%;font-size: small;">
                <div class="col-6">
                    <span>वर्गणीदार : {{ item['title'] }}. {{ item['name'] }}</span><br />
                    <!-- <span>पत्ता <span style="margin-left: 8%;">: द्वारा : {{ item['rep_name'] }}</span></span><br /> -->
                    <span style="margin-left: 17%;">{{ item['address'] }}</span><br />
                    <!-- <span style="margin-left: 17%;">manu mata mandir, Aadgoan</span><br /> -->
                    <span style="margin-left: 17%;">{{ item['district'] }} {{ item['pincode'] }}</span>
                </div>
                <div class="col-1"></div>
                <div class="col-3" style="margin-left: -4%">
                    <div class="col-12" style="border: 2px solid black;padding: 10px; border-radius: 5px;">
                        <span style="margin-left: 7%;padding-left: 20px;">ग्राहक
                            क्र.</span><br />
                            <span style="padding-top: 1%;">{{ item['short_name'] }}
                                {{ item['month'] }}/{{ item['subno'] }}/{{ item['year'] }}</span>
                    </div>
                    <span style="margin-left: 3%;margin-top: 1%;">कच्चा पा क्र.</span><br />
                    <span style="margin-left: 3%;">{{ item['temp_no'] }}  {{ item['temp_no_date'] != '0000-00-00' ? (item['temp_no_date'] | date:'dd/MM/yyyy') : ' ' }}</span>
                </div>
            </div>
            <div class="row" style="margin-left: 6%;margin-top: 1%;font-size: small;">
                <div class="col-6">
                    <span>वर्गणी रक्कम रु. {{ item['net_amt'] }} <span style="margin-left: 5%;">{{ item.receipt_mode }}</span> 
                        <span *ngIf="item.receipt_mode === 'धनादेश'" style="margin-left: 5%;">बँकेचे नाव:- {{ item.bank }} </span>
                    <span *ngIf="item.receipt_mode === 'धनादेश'" style="margin-left: 5%;">शाखेचे नाव:- {{ item.branch_name }} </span></span>
                </div>
            </div>
            <div class="row" style="margin-left: 4%;margin-top: 1%;font-size: small;">
                <div class="col">
                    <span>आपली वर्गणी दि :</span>

                    <!-- <span style="margin-left: 4%;">{{ item['sub_perid_from_date'] | date:'dd/MM/yyyy' }} ते : {{
                        item['sub_perid_to_date'] | date:'dd/MM/yyyy'
                        }}</span> -->

                        <span style="margin-left: 4%;">
                            {{
                            (item['sub_perid_from_date1'] &&
                            item['sub_perid_from_date1'] !== '0000-00-00')
                            ? (item['sub_perid_from_date1'] | date:'dd/MM/yyyy')
                            : (item['sub_perid_from_date'] | date:'dd/MM/yyyy')
                            }}
                            ते :
                            {{
                            (item['sub_perid_from_date1'] &&
                            item['sub_perid_from_date1'] !== '0000-00-00')
                            ? (item['sub_perid_to_date1'] | date:'dd/MM/yyyy')
                            : (item['sub_perid_to_date'] | date:'dd/MM/yyyy')
                            }}
                        </span>

                    <span style="margin-left: 7%;">कालावधीकरिता साभार पोहचली. धन्यवाद!</span>
                </div>
            </div>
            <div class="row" style="margin-left: 4%;margin-top: 1%;font-size: small;">
                <div class="col">
                    <span>(धनादेश वटल्यावरच पावती अधिकृत होईल.)</span>
                </div>
            </div>
            <div class="row" style="margin-left: 4%;margin-top: 1%;font-size: small;">
                <div class="col">
                    <span>पत्रव्यवहार करताना ग्राहक क्रमांकाचा कृपया निर्देश करावा.</span>
                    <span style="margin-left: 10%;border: 1px solid black;padding: 5px;border-radius: 5px;">लेखा
                        विभाग</span>
                    <span style="margin-left: 4%;border: 1px solid black;padding: 5px;border-radius: 5px;">वितरण
                        विभाग</span>
                </div>
            </div>
            <div style="border-width: 0 0 1px 0;border-style: solid; border-color: black;margin-top: 5%;margin-bottom
            : 5%;"></div>
        </div>
    </div>
    </ng-container>
</div>